<template>
	<div>
		
		<el-dialog :visible.sync="showmodal" width="30%">
			<div class="flex my-4 flex-col gap-2 justify-center">
				<div class="flex flex-col gap-2 w-100">
					<div class="font-semibold">Return To:</div>
						<div><input class="input" disabled/></div>
					</div>
				<div class="flex flex-col gap-2 w-100">
					<div class="font-semibold">Address:</div>
						<div>
							<vue-google-autocomplete
								id="map"
								ref="consigneeAddress"
								classname="input"
								placeholder="Enter address"
								
							>
							</vue-google-autocomplete>
						</div>
					</div>
					<div class="flex flex-col gap-2 w-100">
					<div class="font-semibold">State:</div>
						<div>
							<el-select
								filterable
								v-model="state"
								placeholder="Select state"
								@change="fetchCitiesInState"
							>
								<!-- <el-option
									v-for="state in states"
									:key="state.id"
									:label="state.name"
									:value="state.name"
								>
								</el-option> -->
							</el-select>
						</div>
					</div>
					<div class="flex flex-col gap-2 w-100">
						<div class="font-semibold">Country:</div>
							<div>
								<el-select filterable v-model="city" placeholder="Select city">
									<el-option v-for="city in countries" :key="city" :label="city" :value="city">
									</el-option>
								</el-select>
							</div>
						</div>
						<div class="flex flex-col gap-2 w-100">
			<div class="font-semibold">Preferred Day(s):</div>
			<div>
			<el-select filterable multiple v-model="days" placeholder="Select city">
			<el-option v-for="day in daysArray" :key="day" :label="day" :value="day">
			</el-option>
			</el-select>
			</div>
			</div>
			<div class="flex flex-col gap-2 w-100">
			<div class="font-semibold">Preferred Time:</div>
			<div class="flex">
			<!-- <input type="text" class="input w-50" placeholder="00 : 00 am" /> -->
			<el-time-picker
			v-model="preferredPickupTime1"
			placeholder="00 : 00 am"
			format="hh : mm A"
			>
			</el-time-picker>
			<span class="mx-3">-</span>
			<!-- <input type="text" class="input w-50" placeholder="00 : 00 am" /> -->
			<el-time-picker
			v-model="preferredPickupTime2"
			placeholder="00 : 00 am"
			format="hh : mm A"
			>
			</el-time-picker>
			</div>
			</div>

			<div class="flex gap-12 items-center justify-end w-100">
			<p class="cursor-pointer" @click="$emit('close-modal')">Cancel</p>
			<base-button
				text="Next"
				@click="$emit('show-return-cost');$emit('close-modal')"
				:loading="loading"
			/>
			</div>
			</div>	
		</el-dialog>
	</div>
</template>
<script type="text/javascript">
	export default {
		props : {
			showmodal : Boolean
		}
	}
</script>